module.exports = __webpack_public_path__ + "static/media/project4.9500e0cd.png";